/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RoutesAliases {
  ACCREDITATION_UPDATE_CATEGORIES_FRAGMENT = 'accreditation-update-categories-fragment',
  ACCREDITATION_UPDATE_CATEGORIES_ROUTE = 'accreditation-update-categories-route',
  ACCREDITATION_UPDATE_FRAGMENT = 'accreditation-update-fragment',
  ACCREDITATION_UPDATE_ROUTE = 'accreditation-update-route',
  BREADCRUMB_0 = 'breadcrumb-0',
  CALL_CATEGORY_FRAGMENT = 'call-category-fragment',
  CALL_CATEGORY_ROUTE = 'call-category-route',
  CALL_DETAILS_FRAGMENT = 'call-details-fragment',
  CALLS_FRAGMENT = 'calls-fragment',
  CALLS_ROUTE = 'calls-route',
  DASHBOARD_DOCUMENTS_DETAILS = 'dashboard-documents-details',
  DASHBOARD_FRAGMENT = 'dashboard-fragment',
  DASHBOARD_ROUTE = 'dashboard-route',
  DOCUMENTS_DETAILS_FRAGMENT = 'documents-details-fragment',
  FRAGMENT_ACTION_PLAN = 'fragment-action-plan',
  FRAGMENT_ACTION_PLAN_DETAILS = 'fragment-action-plan-details',
  FRAGMENT_ACTION_PLAN_NEW = 'fragment-action-plan-new',
  FRAGMENT_CHANGE_PW = 'fragment-change-pw',
  FRAGMENT_CNES_DETAIL = 'fragment-cnes-detail',
  FRAGMENT_CNES_SEARCH = 'fragment-cnes-search',
  FRAGMENT_CONTRACTS = 'fragment-contracts',
  FRAGMENT_DOCUMENTS = 'fragment-documents',
  FRAGMENT_FORM_TECHNICAL_VISIT = 'fragment-form-technical-visit',
  FRAGMENT_INDICATORS = 'fragment-indicators',
  FRAGMENT_INDICATORS_DETAILS = 'fragment-indicators-details',
  FRAGMENT_MEETING_MINUTE_CONSULTATION = 'fragment-meeting-minute-consultation',
  FRAGMENT_MEETING_MINUTE_DETAILS = 'fragment-meeting-minute-details',
  FRAGMENT_MESSAGE_DETAILS = 'fragment-message-details',
  FRAGMENT_MESSAGES = 'fragment-messages',
  FRAGMENT_MY_DATA = 'fragment-my-data',
  FRAGMENT_NEGOTIATION = 'fragment-negotiation',
  FRAGMENT_NEGOTIATION_DETAILS = 'fragment-negotiation-details',
  FRAGMENT_PRIVACY = 'fragment-privacy',
  FRAGMENT_TASK_DETAILS = 'fragment-task-details',
  FRAGMENT_TASKS = 'fragment-tasks',
  FRAGMENT_TECHNICAL_VISIT = 'fragment-technical-visit',
  FRAGMENT_VISIT_DETAILS = 'fragment-visit-details',
  LAYOUT_ROUTES = 'layout-routes',
  NEW_CALL_DETAILS = 'new-call-details',
  NEW_CALL_FRAGMENT = 'new-call-fragment',
  NEW_CALL_ROUTE = 'new-call-route',
  REPORTS_FRAGMENT = 'reports-fragment',
  ROUTE_ACTION_PLAN = 'route-action-plan',
  ROUTE_ACTION_PLAN_DETAILS = 'route-action-plan-details',
  ROUTE_ACTION_PLAN_NEW = 'route-action-plan-new',
  ROUTE_CHANGE_PW = 'route-change-pw',
  ROUTE_CNES = 'route-cnes',
  ROUTE_CNES_DETAIL = 'route-cnes-detail',
  ROUTE_CONTRACTS = 'route-contracts',
  ROUTE_DOCUMENTS = 'route-documents',
  ROUTE_FORM_TECHNICAL_VISIT = 'route-form-technical-visit',
  ROUTE_INDICATOR_DETAILS = 'route-indicator-details',
  ROUTE_INDICATORS = 'route-indicators',
  ROUTE_MEETING_MINUTE_CONSULTATION = 'route-meeting-minute-consultation',
  ROUTE_MEETING_MINUTE_DETAILS = 'route-meeting-minute-details',
  ROUTE_MESSAGE_DETAILS = 'route-message-details',
  ROUTE_MESSAGES = 'route-messages',
  ROUTE_MY_DATA = 'route-my-data',
  ROUTE_NEGOTIATION = 'route-negotiation',
  ROUTE_NEGOTIATION_DETAILS = 'route-negotiation-details',
  ROUTE_PRIVACY = 'route-privacy',
  ROUTE_REPORTS = 'route-reports',
  ROUTE_TASK_DETAILS = 'route-task-details',
  ROUTE_TASKS = 'route-tasks',
  ROUTE_TECHNICAL_VISIT = 'route-technical-visit',
  ROUTE_VISIT_DETAILS = 'route-visit-details',
}
export { RoutesAliases };
